import r from "../managers/braze-instance.js";
import ra from "./push-manager-factory.js";
export function requestPushPermission(n, o) {
  if (r.rr()) return ra.ea().subscribe(function (o, t, e) {
    var s = r.nn();
    s && s.requestImmediateDataFlush(), "function" == typeof n && n(o, t, e);
  }, o);
}